import React from 'react'
import Modal from '@components/common/modal/Modal'

interface InfoModalProps {
  title: string
  content: React.ReactNode
  width?: string
  height?: string
  noHeader?: boolean
  close: () => void
}

const InfoModal = ({
  title,
  content,
  noHeader = false,
  close,
  width = '1000px',
  height = '80vh',
}: InfoModalProps) => {
  return (
    <Modal
      title={title}
      hideModal={close}
      color="#001940"
      width={width}
      height={height}
      noHeader={noHeader}
    >
      {content}
    </Modal>
  )
}

export default InfoModal
